export function isMatchIndexFilter(filter) {
    return filter.equals !== undefined;
}
export function isRangeIndexFilter(filter) {
    return (filter.gte !== undefined ||
        filter.lte !== undefined ||
        filter.gt !== undefined ||
        filter.lt !== undefined);
}
export function isCompoundIndexFilter(filter) {
    return !!filter.match;
}
export function isStartsWithIndexFilter(filter) {
    return filter.startsWith !== undefined;
}
export function isSortIndexFilter(filter) {
    return (!isRangeIndexFilter(filter) &&
        !isMatchIndexFilter(filter) &&
        !isCompoundIndexFilter(filter) &&
        !isStartsWithIndexFilter(filter) &&
        filter.order);
}
export function isMultiValueIndex(collectionSchema, indexName) {
    var _a, _b;
    const compound = (_a = collectionSchema.compounds) === null || _a === void 0 ? void 0 : _a[indexName];
    if (compound) {
        return compound.of.some((fieldOrIndexName) => {
            return isMultiValueIndex(collectionSchema, fieldOrIndexName);
        });
    }
    const index = (_b = collectionSchema.indexes) === null || _b === void 0 ? void 0 : _b[indexName];
    if (index) {
        if ('type' in index) {
            return isMultiEntryIndexType(index.type);
        }
        if ('field' in index) {
            const field = collectionSchema.fields[index.field];
            if (!field)
                return false;
            return isMultiEntryIndexType(field.type);
        }
    }
    const field = collectionSchema.fields[indexName];
    if (!field)
        return false;
    return isMultiEntryIndexType(field.type);
}
function isMultiEntryIndexType(type) {
    return type === 'array' || type.endsWith('[]');
}
//# sourceMappingURL=indexFilters.js.map